module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [(_vm.withTitle) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dark": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          Custom shared calendar\n          "), _c('v-chip', {
    staticClass: "v-chip--x-small"
  }, [_vm._v("Read only")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.req.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.date && _vm.calendarId) ? _c('day-view', {
    staticClass: "ml-0",
    attrs: {
      "flat": "",
      "readOnly": true,
      "date": _vm.date,
      "with-fetch": false,
      "start-hour": _vm.settings.startHour,
      "end-hour": _vm.settings.endHour,
      "events": _vm.events
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d4c4268","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/SharedCalendarDayView.vue
// module id = 1668
// module chunks = 3